module.exports = __webpack_public_path__ + "img/1753839502783-WhatsApp Image 2025-07-30 at 09.29.50.jpeg.2f9edc16.webp";